import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchStoreProductsService,
  fetchStoreSellerService,
  toggleStoreFollowService,
} from "./store.service";
import {
  StoreProductsParams,
  StoreProductsData,
  StoreSeller,
  StoreSellerData,
  ToggleFollowData,
} from "./store.types";
import { ApiResponse } from "../../api/api.types";

export const getStoreProducts = createAsyncThunk<
  { slug: string; data: StoreProductsData },
  { slug: string; params?: StoreProductsParams },
  { rejectValue: string }
>("store/getStoreProducts", async ({ slug, params }, { rejectWithValue }) => {
  try {
    const response: ApiResponse<StoreProductsData> =
      await fetchStoreProductsService(slug, params);
    return { slug, data: response.data };
  } catch {
    return rejectWithValue("Mağaza ürünleri yüklenemedi.");
  }
});

export const getStoreSeller = createAsyncThunk<
  StoreSeller,
  string,
  { rejectValue: string }
>("store/getStoreSeller", async (slug, { rejectWithValue }) => {
  try {
    const response: ApiResponse<StoreSellerData> =
      await fetchStoreSellerService(slug);
    return response.data.seller;
  } catch {
    return rejectWithValue("Mağaza bulunamadı.");
  }
});

export const getStoreFullData = createAsyncThunk<
  { slug: string; data: StoreSellerData },
  string,
  { rejectValue: string }
>("store/getStoreFullData", async (slug, { rejectWithValue }) => {
  try {
    const response: ApiResponse<StoreSellerData> =
      await fetchStoreSellerService(slug);
    return { slug, data: response.data };
  } catch {
    return rejectWithValue("Mağaza verileri yüklenemedi.");
  }
});

export const toggleStoreFollow = createAsyncThunk<
  ToggleFollowData,
  number,
  { rejectValue: string }
>("store/toggleStoreFollow", async (id, { rejectWithValue }) => {
  try {
    const response: ApiResponse<ToggleFollowData> =
      await toggleStoreFollowService(id);
    return response.data;
  } catch {
    return rejectWithValue("Takip işlemi gerçekleştirilemedi.");
  }
});
